export default __webpack_public_path__ + "static/media/clock.7a649981.gif";